import moment from 'moment';
import { PaginatedDataEntity } from '../../../lib/types/Settlement';
import Modal from '../../common/modal/Modal';
import Button from '../../ui/Button';
import styles from './style.module.scss';

type SettlementDetailsModalProps = {
  open: boolean;
  onClose: () => void;
  data?: PaginatedDataEntity | null;
};

const SettlementDetailsModal = ({
  onClose,
  open,
  data,
}: SettlementDetailsModalProps) => {
  return (
    <Modal
      open={open}
      title="Settlement Details"
      onClose={onClose}
      dialogClassName={styles.dialog_content}
    >
      <div className={styles.settlementWrapper}>
        <div className={styles.settlementItem}>
          <label>Client Name</label>
          <span>
            {data?.createdBy?.firstName} {data?.createdBy?.lastName}
          </span>
        </div>
        <div className={styles.settlementItem}>
          <label>Department</label>
          <span>-</span>
        </div>
        <div className={styles.settlementItem}>
          <label>Transaction Date</label>
          <span>{moment(data?.createdAt).format('DD MMM YYYY, HH:mm:ss')}</span>
        </div>
        <div className={styles.settlementItem}>
          <label>Settlement Status</label>
          <span
            className={`${data?.status?.toLowerCase() === 'pending' ? styles.pending : data?.status?.toLowerCase() === 'failed' ? styles.failed : styles.settled}`}
          >
            {data?.status?.toLowerCase() === 'pending'
              ? 'Pending'
              : data?.status?.toLocaleLowerCase() === 'failed'
                ? 'Rejected'
                : 'Settled'}
          </span>
        </div>
        <div className={styles.settlementItem}>
          <label>Redeemed Tokens</label>
          <span>{data?.tokenTransactions?.tokenAmount}</span>
        </div>
        <div className={styles.settlementItem}>
          <label>Settlement Type</label>
          <span>{data?.transactionsMode}</span>
        </div>
        <div className={styles.settlementItem}>
          <label>Fiat </label>
          <span>{data?.amount}</span>
        </div>
      </div>

      {/* <div className={styles.actions}>
        <Button variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="dark"
          disabled
          onClick={() => {
            onClose();
          }}
          className={styles.delete_btn}
        >
          Download Receipt
        </Button>
      </div> */}
    </Modal>
  );
};

export default SettlementDetailsModal;
